module.exports = __webpack_public_path__ + "static/media/kz.aebe1ef9.svg";